var FIXED_PURCHASE_QTY, confirmationRedirect, getIovationBlackBox, getTotal, hasErrors, lazyLoadJs, receiptRedirect, shouldBucketTheUserIntoExp, showPaymentSheet;

lazyLoadJs = require('./helpers').lazyLoadJs;

FIXED_PURCHASE_QTY = 1;

getTotal = function(amount, type) {
  var total;
  amount = amount.replace(/\$|\s/g, '');
  total = {
    label: I18n.t('js.modules.applepay.total'),
    amount: amount
  };
  if (type) {
    total.type = type;
  }
  return total;
};

confirmationRedirect = function(url) {
  return window.location = url + "&msg=complete_failed";
};

receiptRedirect = function(url) {
  return window.location = url;
};

hasErrors = function(res) {
  var ref, ref1;
  return ((ref = res.flashErrors) != null ? ref.length : void 0) > 0 || ((ref1 = res.apiErrors) != null ? ref1.length : void 0) > 0 || res.error;
};

showPaymentSheet = function(opts) {
  var confirmationUrl, countryCode, csrf, currencyCode, dealId, ioBlackBox, matches, optionId, paymentRequest, session, totalAmount;
  totalAmount = opts.totalAmount, currencyCode = opts.currencyCode, csrf = opts.csrf, confirmationUrl = opts.confirmationUrl, ioBlackBox = opts.ioBlackBox;
  countryCode = I18n.country;
  matches = /\/deals\/(.+)\/confirmation\?pledge_id=([0-9]+)/.exec(confirmationUrl);
  dealId = matches[1];
  optionId = matches[2];
  if (!dealId || !optionId) {
    window.location = confirmationUrl;
    return;
  }
  paymentRequest = {
    currencyCode: currencyCode,
    countryCode: countryCode,
    total: getTotal(totalAmount),
    supportedNetworks: ['amex', 'discover', 'masterCard', 'visa'],
    merchantCapabilities: ['supports3DS'],
    requiredBillingContactFields: ['postalAddress', 'email']
  };
  session = new ApplePaySession(1, paymentRequest);
  session.onpaymentauthorized = function(event) {
    var billingContact, payload, ref, token;
    ref = event.payment, billingContact = ref.billingContact, token = ref.token;
    payload = {
      ioBlackBox: ioBlackBox,
      items: [
        {
          deal_id: dealId,
          option_id: optionId,
          quantity: FIXED_PURCHASE_QTY
        }
      ],
      encrypted_payment_data: JSON.stringify(token.paymentData),
      type: 'applepay',
      billing_record: {
        payment_id: 'applepay',
        type: 'applepay',
        street_address_1: billingContact.addressLines.join(', '),
        country: billingContact.country,
        city: billingContact.locality,
        state: billingContact.administrativeArea,
        postal_code: billingContact.postalCode
      }
    };
    return $.ajax({
      type: 'POST',
      contentType: 'application/x-www-form-urlencoded',
      dataType: 'json',
      url: '/deals/new/orders',
      headers: {
        "x-csrf-token": csrf
      },
      data: payload,
      success: function(data) {
        if (hasErrors(data)) {
          session.completePayment(ApplePaySession.STATUS_FAILURE);
          return confirmationRedirect(confirmationUrl);
        } else {
          session.completePayment(ApplePaySession.STATUS_SUCCESS);
          return receiptRedirect(data.url);
        }
      },
      error: function() {
        session.completePayment(ApplePaySession.STATUS_FAILURE);
        return confirmationRedirect(confirmationUrl);
      }
    });
  };
  session.onpaymentmethodselected = function(e) {
    return session.completePaymentMethodSelection(getTotal(totalAmount, 'final'), []);
  };
  session.onvalidatemerchant = function(arg) {
    var validationURL;
    validationURL = arg.validationURL;
    return $.ajax({
      type: 'POST',
      dataType: 'json',
      data: {
        url: validationURL
      },
      headers: {
        "x-csrf-token": csrf
      },
      url: '/checkout/payment/validation',
      success: function(merchantSession) {
        return session.completeMerchantValidation(merchantSession);
      }
    });
  };
  return session.begin();
};

shouldBucketTheUserIntoExp = function(expName, cb) {
  return Finch.experiment(expName, {
    Control: function() {
      return cb(false);
    },
    Treatment: function() {
      return cb(true);
    }
  });
};

getIovationBlackBox = function(iovationUrl, cb) {
  window.io_bbout_element_id = 'ioBlackBox';
  window.io_install_flash = false;
  window.io_enable_rip = true;
  window.io_install_stm = false;
  window.io_exclude_stm = 12;
  $('body').append("<input type='hidden' name='" + io_bbout_element_id + "' id='" + io_bbout_element_id + "'>");
  return lazyLoadJs(iovationUrl, function() {
    return cb($("#" + io_bbout_element_id).val());
  });
};

module.exports = {
  hasValidConfirmationLink: function(href) {
    return href.match(/\/deals\/.+\/confirmation\?pledge_id=[0-9]+/i);
  },
  start: function(opts, getTotalAmount, getApplePayButton, renderApplePayFeature, updatePromoCodeHandler, getConfirmationUrl, expName) {
    if (!(window.ApplePaySession && opts.isApplePayEnabled)) {
      return;
    }
    return ApplePaySession.canMakePaymentsWithActiveCard(opts.appleMerchantId).then(function(canMakePayments) {
      if (!canMakePayments) {
        return;
      }
      return $.get('/deals/proxy/user/valid', function(arg) {
        var isApplePayEligible;
        isApplePayEligible = arg.isApplePayEligible;
        if (!isApplePayEligible) {
          return;
        }
        return shouldBucketTheUserIntoExp(expName, function(res) {
          if (!res) {
            return;
          }
          return getIovationBlackBox(opts.iovationUrl, function(ioBlackBox) {
            updatePromoCodeHandler();
            renderApplePayFeature();
            return getApplePayButton().click(function(e) {
              var totalAmount;
              totalAmount = getTotalAmount();
              showPaymentSheet(_.extend({}, opts, {
                totalAmount: totalAmount,
                ioBlackBox: ioBlackBox,
                confirmationUrl: getConfirmationUrl()
              }));
              return false;
            });
          });
        });
      });
    });
  }
};

//# sourceMappingURL=data:application/json;base64,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
